const adaHideWhenVertical = () => {
	setTimeout(function () {
		$('#vert-rec .rec-list li').each(function () {
			if ($('.tabletPage').length > 0 && window.innerHeight > 1290) {
				$('#vert-rec .rec-list li').slice(3).attr('aria-hidden', 'true').find('a').attr('tabindex', '-1');
			} else {
				$('#vert-rec .rec-list li').slice(5).attr('aria-hidden', 'true').find('a').attr('tabindex', '-1');
			}
		});
	}, 4000);
};

const adaHideWhenHorizontal = () => {
	setTimeout(function () {
		$('#vert-rec .rec-list li').each(function () {
			var fromLeftOfScreen = $(window).innerWidth(),
				//We have 40px of padding between the horizontal rec wrapper and the screen width.
				fromLeftOfScreen = fromLeftOfScreen - 40,
				coords = $(this)[0].getBoundingClientRect();
			//We want to target the middle x coordinate of the image. This way we can determine if there's enough of the image showing to be tapped.
			//The horizontal recs images on mobile are 130px wide, therefore we need to split the diff and add 65 to the x coordinate.
			if (parseFloat(coords.x + 65) < parseFloat(0) || parseFloat(coords.x) > parseFloat(fromLeftOfScreen)) {
				$(this).attr('aria-hidden', 'true');
			} else {
				$(this).removeAttr('aria-hidden');
			}
		});
	}, 2000);
};

// desktop and tablet
const desktopTabletVerticalRecs = () => {
	if ($('.desktopPage').length > 0) {
		adaHideWhenVertical();
	}
	if ($('.tabletPage').length > 0 && window.innerWidth > window.innerHeight) {
		adaHideWhenVertical();
	}
	if ($('.tabletPage').length > 0 && window.innerHeight > 1290) {
		adaHideWhenVertical();
	} else {
		if ($('.tabletPage').length > 0 && window.innerHeight > window.innerWidth) {
			adaHideWhenHorizontal();
			$('#vert-rec').on('touchend', function () {
				adaHideWhenHorizontal();
			});
		}
	}

	$(window).on('orientationchange', function () {
		setTimeout(function () {
			if ($('.tabletPage').length > 0 && window.innerHeight > 1290) {
				$('ul.rec-list').css('top', '0');
				$('#vert-rec').off();
				$('#vert-rec .rec-list li').each(function () {
					$('#vert-rec .rec-list li').removeAttr('aria-hidden').find('a').removeAttr('tabindex');
				});
				if(($('#shopping-bag tr').length - 1) == 3){
					$('#rec-list-contain').css('cssText', 'height:1095px !important;')
			}else if(($('#shopping-bag tr').length - 1) == 4){
					$('#rec-list-contain').css('cssText', 'height:1310px !important;')
			}else if(($('#shopping-bag tr').length - 1) >= 5){
					$('#rec-list-contain').css('cssText', 'height:1525px !important;')
			}
				adaHideWhenVertical();
			}
			if ($('.tabletPage').length > 0 && window.innerWidth > window.innerHeight) {
				$('ul.rec-list').css('top', '0');
				$('#vert-rec').off();
				$('#vert-rec .rec-list li').each(function () {
					$('#vert-rec .rec-list li').removeAttr('aria-hidden').find('a').removeAttr('tabindex');
				});
				if(($('#shopping-bag tr').length - 1) == 3){
					$('#rec-list-contain').css('cssText', 'height:1095px !important;')
			}else if(($('#shopping-bag tr').length - 1) == 4){
					$('#rec-list-contain').css('cssText', 'height:1310px !important;')
			}else if(($('#shopping-bag tr').length - 1) >= 5){
					$('#rec-list-contain').css('cssText', 'height:1525px !important;')
			}
				adaHideWhenVertical();
			} else {
				if ($('.tabletPage').length > 0 && window.innerHeight < 1290 && window.innerHeight > window.innerWidth) {
					$('#vert-rec #rec-list-contain').css('height', '');
					adaHideWhenHorizontal();
					$('#vert-rec').on('touchend', function () {
						adaHideWhenHorizontal();
					});
				}
			}
		}, 1000);
	});

	$('#topRecButtonDown, #bottomRecButtonDown').on('click', function () {
		$('button.nav-up').removeClass('disabled-arrow');
		var vertRecNavPos = $('#vert-rec .rec-list').position().top,
			recListHeightDiff = $('#vert-rec .rec-list').height() - $('#vert-rec #rec-list-contain').height();
		if (recListHeightDiff > (vertRecNavPos - 135) * -1 && !$('#vert-rec .rec-list').is(':animated'))
			$('#vert-rec .rec-list').animate({
				top: '-=205',
			});
		if (!$('#topRecButtonDown, #bottomRecButtonDown').hasClass('disabled-arrow')) {
			$('#vert-rec .rec-list li[aria-hidden!="true"]:first').attr('aria-hidden', 'true').find('a').attr('tabindex', '-1');
			$('#vert-rec .rec-list li[aria-hidden!="true"]:last').next('[aria-hidden="true"]').removeAttr('aria-hidden').find('a').removeAttr('tabindex');
		}
		if (recListHeightDiff < (vertRecNavPos - 155) * -1) $('button.nav-down').addClass('disabled-arrow');
		return false;
	});
	$('#topRecButtonUp, #bottomRecButtonUp').on('click', function () {
		$('button.nav-down').removeClass('disabled-arrow');
		var vertRecNavPos = $('#vert-rec .rec-list').position().top;
		if (vertRecNavPos != 0 && !$('#vert-rec .rec-list').is(':animated'))
			$('#vert-rec .rec-list').animate({
				top: '+=205',
			});
		if (!$('#topRecButtonUp, #bottomRecButtonUp').hasClass('disabled-arrow')) {
			$('#vert-rec .rec-list li[aria-hidden!="true"]:first').prev().removeAttr('aria-hidden').find('a').removeAttr('tabindex');
			$('#vert-rec .rec-list li[aria-hidden!="true"]:last').attr('aria-hidden', 'true').find('a').attr('tabindex', '-1');
		}
		if (vertRecNavPos > -230) $('button.nav-up').addClass('disabled-arrow');
		return false;
	});
};

// mobile
const mobileVerticalRecs = () => {
	adaHideWhenHorizontal();
	$('#vert-rec').on('touchend', function () {
		adaHideWhenHorizontal();
	});
};

export { desktopTabletVerticalRecs, mobileVerticalRecs };